import { ArchiveConfirmationModalProvider } from '@/components/ConfirmationModal/Archive/Modal';
import { InlineErrorProvider } from '@/context/InlineErrorContext/InlineErrorContext';
import { BusinessDocumentDetail as BusinessDocumentDetailType } from '@/context/services/business_document/type';
import { BusinessDocumentDetail } from '@/features/business_documents/Detail';
import { ProcessingStatusProvider } from '@/features/business_documents/Detail/Context/ProcessingStatus';
import { DrawerTitle } from '@/features/business_documents/List/Table/Drawer/components/DrawerTitle/DrawerTitle';
import { DEFAULT_DRAWER_DETAIL_WIDTH } from '@/features/business_documents/UploadForm/Content/constant';
import { useGetFlags } from '@/hooks/useFeatureFlag';
import { DraggableDrawer } from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { FC, memo, useEffect, useState } from 'react';
import styles from './Drawer.module.scss';

const cx = classnames.bind(styles);

export type Props = {
  selectedId: string;
  open: boolean;
  onClose: () => void;
};

export const Drawer: FC<Props> = memo(({ selectedId, open, onClose }) => {
  const [width, setWidth] = useState(DEFAULT_DRAWER_DETAIL_WIDTH);
  const [data, setData] = useState<BusinessDocumentDetailType | null>(null);
  const flagBusinessDrawerHeader = useGetFlags(
    'BUSINESS_DOCUMENT_DRAWER_HEADER'
  );
  useEffect(() => {
    setWidth(DEFAULT_DRAWER_DETAIL_WIDTH);
  }, [open]);

  const processingStatus = {
    OCRStatus: data?.automatic_status,
    timestampStatus: data?.timestamp_status,
    isArchived: !!data?.archived,
  };

  return (
    <ProcessingStatusProvider value={processingStatus}>
      <InlineErrorProvider>
        <ArchiveConfirmationModalProvider>
          <DraggableDrawer
            width={width}
            setWidth={setWidth}
            visible={open}
            onClose={onClose}
            withOutDefaultTitle={!flagBusinessDrawerHeader}
            contentContainerClassName={cx(styles['contentContainer'])}
            minWidth={DEFAULT_DRAWER_DETAIL_WIDTH}
            title={
              flagBusinessDrawerHeader && data ? (
                <DrawerTitle data={data} />
              ) : null
            }
          >
            <BusinessDocumentDetail
              data-testid={selectedId}
              key={selectedId}
              id={selectedId}
              onClose={onClose}
              setData={setData}
            />
          </DraggableDrawer>
        </ArchiveConfirmationModalProvider>
      </InlineErrorProvider>
    </ProcessingStatusProvider>
  );
});
Drawer.displayName = 'Drawer';
